import React, { Component, Suspense } from 'react';
import { withRouter, matchPath } from 'react-router-dom';
import { Nav, Navbar, NavItem, NavLink } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import logo from '../../assets/img/brand/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Icons from '@fortawesome/free-solid-svg-icons';
import { compose } from 'redux';
import { connect } from 'react-redux';

class MainSidebar extends Component {
    constructor(props, context) {
        super(props, context);
    };

    renderNav(pathName) {
        const currPath = '/' + pathName.split('/')[1]; 
        const root = this.props.currentUser.nav.filter((navItem) => { return navItem.url == currPath })
        var navItems = root[0] != undefined ? root[0].children : undefined;
       const items = navItems != undefined ? navItems.map((navitem, idx) => {
           return (
               <li className="nav-item" key={idx}>
                    <LinkContainer to={navitem.url}>
                        <a className="nav-link">
                            <FontAwesomeIcon icon={Icons[navitem.icon]} className="nav-icon" /> {navitem.name}
                        </a>
                    </LinkContainer>
                </li>
            )
        }) : null;
        return items;
    }

    render() {

        return (
            <div className="sidebar bg-medium" id="sideNavBar" name="sideNavBar">

                <div className="sidebar-header bg-light">

                    <LinkContainer to={this.props.currentUser.dashboard}>
                        <a className="sidebar-brand float-left navbar-brand" href='#'>
                            <img
                                src={logo}
                                width="137"
                                height="40"
                                className="d-inline-block align-top"
                                alt="Generic Logo"
                            />
                        </a>
                    </LinkContainer>
                </div>
                <ul className="nav">
                    {this.renderNav(this.props.location.pathname)}
                    {
                    //<li className="nav-item">
                    //    <LinkContainer to="/coding/worksheet">
                    //        <a className="nav-link">
                    //            Worksheet
                    //        </a>
                    //        </LinkContainer>
                    //    </li>
                    }
                    </ul>
            </div>
        );
    }
}

//export default withRouter(MainSidebar);
export default compose(withRouter, connect(state => state.applicationContext))(MainSidebar);
